let local = {
_strMapToObj(strMap)
{
    let obj = Object.create(null);
    for (let [k, v] of strMap) {
        obj[k] = v;
    }
    return obj;
},
_mapToJson(map)
{
    return JSON.stringify(this._strMapToObj(map));
},
_objToStrMap(obj){
    let strMap = new Map();
    for (let k of Object.keys(obj)) {
        strMap.set(k,obj[k]);
    }
    return strMap;
},
_jsonToMap(jsonStr){
    return this._objToStrMap(JSON.parse(jsonStr));
}
}
export default {
  install: function(vm){
    vm.prototype.$local = local
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/MapToJsonAndJsonToMap.js